import { Component } from '@angular/core';

@Component({
  selector: 'app-registered-club-contents',
  templateUrl: './registered-club-contents.component.html',
  styleUrls: ['./registered-club-contents.component.css']
})
export class RegisteredClubContentsComponent {

}
